import React, { Component } from "react";
import PropTypes from "prop-types";
import DownloadButton from "./DownloadButton";

const downloadsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        index: PropTypes.number,
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
    })
);

class ProductModal extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        id: PropTypes.string,
        image: PropTypes.string,
        title: PropTypes.string,
        code: PropTypes.string,
        name: PropTypes.string,
        downloads: downloadsPropType,
        familyDownloads: downloadsPropType,
        bundleSize: PropTypes.string,
        bundleUrl: PropTypes.string,
        onCrossClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        downloads: [],
        familyDownloads: []
    };

    handleClick = () => {
        this.props.onCrossClick();
    };

    render() {
        const {
            active,
            image,
            code,
            name,
            downloads,
            familyDownloads,
            bundleSize,
            bundleUrl
        } = this.props;

        return (
            <>
                <div
                    className={`modal-overlay ${active ? "is-active" : ""}`}
                    onClick={this.handleClick}
                />
                <div className={`modal ${active ? "is-active" : ""}`}>
                    <div className="modal__wrap">
                        <div className="modal__container">
                            <div className="modal__head">
                                <div className="modal__title">Product Kit</div>
                                <div
                                    className="modal__cross"
                                    onClick={this.handleClick}
                                >
                                    <span />
                                    <span />
                                </div>
                            </div>

                            <div className="modal__scroller">
                                <div className="modal__body">
                                    <div className="modal__product">
                                        <div className="modal__product-image">
                                            <span>
                                                {image && (
                                                    <img
                                                        src={image}
                                                        alt={code}
                                                    />
                                                )}
                                            </span>
                                        </div>
                                        <div className="modal__product-content">
                                            <div className="modal__product-code">
                                                {code}
                                            </div>
                                            <div className="modal__product-desc">
                                                {name}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal__content">
                                        <div className="downloads-list downloads-list--dark">
                                            <div className="downloads-list__title">
                                                Downloads
                                            </div>

                                            <ul className="downloads-list__ul">
                                                {downloads.map(download => (
                                                    <li
                                                        key={download.id}
                                                        className="downloads-list__li"
                                                    >
                                                        <div className="downloads-list__item">
                                                            <div className="downloads-list__name">
                                                                {download.title}
                                                            </div>
                                                            <div className="downloads-list__size">
                                                                {download.size}
                                                            </div>
                                                            <a
                                                                href={
                                                                    download.url
                                                                }
                                                                className="downloads-list__item-download"
                                                            />
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal__foot">
                                    <div className="modal__list">
                                        <div className="modal__list-title">
                                            The full Product Kit includes all
                                            downloads listed above plus the
                                            following:
                                        </div>
                                        <ul className="modal__list-ul">
                                            {familyDownloads.map(download => (
                                                <li
                                                    key={`${download.id}-${
                                                        download.index
                                                    }`}
                                                    className="li li--white"
                                                >
                                                    <span className="file-name">
                                                        {download.title}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="modal__button">
                                        {bundleUrl && (
                                            <DownloadButton
                                                url={bundleUrl}
                                                size={bundleSize}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ProductModal;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/ProductModal.js